export const Team = ({
    LAVAL_LEGENDS: 0, // 'Lava Legends',
    EMERALD_KNIGHTS: 1, // 'Emerald Nights',
    OBSIDIAN_OUTLAWS: 2, // 'Obsidian Outlaws',
    NETHERSTORM_RAIDERS: 3, // 'Netherstorm Raiders',
    DIAMOND_DYNASTY: 4, // 'Diamond Dynasty',
    ENDER_WARRIORS: 5, // 'Ender Warriors',
    UNKNOWN: 6,
    TEST_TEAM: 7,
});

export const TEAM_DATA = {
    [Team.LAVAL_LEGENDS]: {
        name: 'Lava Legends',
        color: '#FF4500', // Bright orange-red
        members: ['Wichtiger', 'NiceTwice']
    },
    [Team.EMERALD_KNIGHTS]: {
        name: 'Emerald Nights',
        color: '#50C878', // Bright green
        members: ['Hugo', 'Dimeax']
    },
    [Team.OBSIDIAN_OUTLAWS]: {
        name: 'Obsidian Outlaws',
        color: '#8a5ffb',
        members: ['CastCrafter', 'misfit']
    },
    [Team.NETHERSTORM_RAIDERS]: {
        name: 'Netherstorm Raiders',
        color: '#ff7272', // Deep red
        members: ['Tjan', 'Chaosflo']
    },
    [Team.DIAMOND_DYNASTY]: {
        name: 'Diamond Dynasty',
        color: '#B0E0E6', // Light blue
        members: ['Stegi', 'MultiPorl']
    },
    [Team.ENDER_WARRIORS]: {
        name: 'Ender Warriors',
        color: '#4B0082', // Indigo (mix of black and purple)
        members: ['None1', 'None1']
    },
    [Team.UNKNOWN]: {
        name: 'Unknown',
        color: '#808080', // Neutral gray
        members: ['Unknown2', 'Unknown2']
    },
    [Team.TEST_TEAM]: {
        name: 'Test Team',
        color: '#D3D3D3', // Light gray
        members: ['Test1', 'Test2']
    },
};

export const CURRENT_VERSION = 'version8';
export const TOURNAMENT_SEEDS = ['123456789', '7890', '3893344064374398105', '956602649452601670', '9195925561432886669'];

export const TEAMS: Record<number, Array<string>> = {
    [Team.LAVAL_LEGENDS]: ['Wichtiger', 'NiceTwice'],
    [Team.EMERALD_KNIGHTS]: ['LetsHugo', 'Dimeax'],
    [Team.OBSIDIAN_OUTLAWS]: ['CastCrafter', 'misfit'],
    [Team.NETHERSTORM_RAIDERS]: ['Tjan', 'Chaosflo44'],
    [Team.DIAMOND_DYNASTY]: ['Stxgi', 'MultiPori'],
};

export const PRETTY_NAMES: Record<string, string> = {
    'NiceTwice': 'NiceTwice',
    'LetsHugo': 'Hugo',
    'Dimeax': 'Dimeax',
    'Tjan': 'Tjan',
    'Chaosflo44': 'Chaosflo',
    'CastCrafter': 'CastCrafter',
    'wichtiger': 'Wichtiger',
    'misfit': 'Misfit',
    'Stxgi': 'Stegi',
    'multiporl': 'MultiPorl',
};

export function getPlayerImage(name: string) {
    return `https://peeposprint.at/assets/member/${name.toLowerCase()}.png`;
}

export function getTeam(team: number) {
    if(TEAM_DATA.hasOwnProperty(team)) {
        return TEAM_DATA[team];
    }
    return TEAM_DATA[Team.UNKNOWN];
}
